export enum MapSearchType {
  ALL,
  ADDRESS_PLACES,
  WHAT3WORDS,
  ZONES_AREAS,
  VENUE_MAPS
}
